import { InfographicRowInputs } from './InfographicRow';

export const infographicsTransformer = (node): InfographicRowInputs => {
    if (node.type === `paragraph__tile_row_1_column`) {
        return {
            title: node.field_tile_title,
            cells: [
                {
                    color: node.field_tile_color,
                    mainText: node.field_tile_header,
                    subtext: node.field_tile_text,
                    col: 12,
                    imageAlt: node.field_tile_image?.alt,
                    image: node.relationships?.field_tile_image?.localFile,
                },
            ],
        };
    } else if (node.type === `paragraph__tile_row_2_columns`) {
        return {
            cells: [
                {
                    color: node.field_tile_color,
                    mainText: node.field_tile_header,
                    subtext: node.field_tile_text,
                    col: 6,
                    imageAlt: node.field_tile_image?.alt,
                    image: node.relationships?.field_tile_image?.localFile,
                },
                {
                    color: node.field_tile_color,
                    mainText: node.field_tile_header_2,
                    subtext: node.field_tile_text_2,
                    col: 6,
                    imageAlt: node.field_tile_image_2?.alt,
                    image: node.relationships?.field_tile_image_2?.localFile,
                },
            ],
        };
    } else if (node.type === `paragraph__tile_row_3_columns`) {
        return {
            cells: [
                {
                    color: node.field_tile_color,
                    mainText: node.field_tile_header,
                    subtext: node.field_tile_text,
                    col: 4,
                },
                {
                    color: node.field_tile_color,
                    mainText: node.field_tile_header_2,
                    subtext: node.field_tile_text_2,
                    col: 4,
                },
                {
                    color: node.field_tile_color,
                    mainText: node.field_tile_header_3,
                    subtext: node.field_tile_text_3,
                    col: 4,
                },
            ],
        };
    } else if (node.type === `paragraph__tile_row_custom`) {
        return {
            cells: [
                {
                    color: node.field_tile_color,
                    col: 12,
                    mainText: node.field_tile_header,
                    subtext: node.field_tile_text,
                    leadingImages: [
                        {
                            alt: node.field_tile_image?.alt,
                            image: node.relationships?.field_tile_image
                                ?.localFile,
                        },
                        {
                            alt: node.field_tile_image_2?.alt,
                            image: node.relationships?.field_tile_image_2
                                ?.localFile,
                        },
                    ],
                    trailingImages: [
                        {
                            alt: node.field_tile_image_3?.alt,
                            image: node.relationships?.field_tile_image_3
                                ?.localFile,
                        },
                        {
                            alt: node.field_tile_image_4?.alt,
                            image: node.relationships?.field_tile_image_4
                                ?.localFile,
                        },
                    ],
                },
            ],
        };
    }
};
